import { ComboBox, type ComboBoxChangeEvent } from "@progress/kendo-react-dropdowns";
import type { RetailerDto } from "../../../../contracts";

type RetailerSelectorProps = {
    value: RetailerDto | null;
    retailers: RetailerDto[];
    isFetching: boolean;
    disabled: boolean;
    onChange: (retailerId: number | null) => void;
};

const RetailerSelector: React.FC<RetailerSelectorProps> = ({
    value,
    retailers,
    isFetching,
    disabled,
    onChange
}: RetailerSelectorProps) => {
    return (
        <div className="col-12">
            <label className="form-label small fw-semibold">
                Retailer
            </label>
            <ComboBox
                data={retailers}
                dataItemKey="id"
                textField="name"
                loading={isFetching}
                value={value}
                placeholder={isFetching ? "Loading retailers..." : "Select retailer"}
                disabled={disabled || isFetching}
                clearButton={true}
                style={{ width: "100%" }}
                onChange={(event: ComboBoxChangeEvent): void => {
                    const data: RetailerDto | null = event.value;
                    onChange(data?.id ?? null);
                }}
            />
        </div>
    );
};

export default RetailerSelector;
